import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ArticleCard from '../Lander/ArticleCard';
import { determineCardType } from '../../imgixUtils';
import '../Lander/lander-one.scss';

class Recirculation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numArticles: 6,
    };
    this.handleSeeMoreClick = this.handleSeeMoreClick.bind(this);
    this.organizeArticles = this.organizeArticles.bind(this);
    this.renderArticleCards = this.renderArticleCards.bind(this);
  }

  handleSeeMoreClick() {
    let { numArticles } = this.state;
    numArticles += 6;

    this.setState({
      numArticles,
    });
  }

  // this method exists in Lander/index.js and a couple of other, similar components. saving for a future refactor (may want to do after the ImageModule refactor as changes to existing logic may be required).
  organizeArticles(numArticles, articles) {
    // articles are treated as either big-card or small-card in Recirculation. featured doesn't matter.
    const nextArticles = articles.slice(0, numArticles);

    const articlesWithCardClasses = nextArticles.map((article, i) => {
      return {
        ...article,
        // when i is <= 3 the cardClass becomes "top-card", which we don't want here.
        cardClass: determineCardType(i + 4, false)
      }
    });

    return articlesWithCardClasses;
  }

  renderArticleCards(articleCards) {
    const { isMobile } = this.props;
    return articleCards.map((articleCard, i) => <ArticleCard key={i} data={articleCard} isMobile={isMobile} shouldDisplaySponsored={false}/>);
  }

  render() {
    const { articles, recirculation, isMobile } = this.props;
    let { numArticles } = this.state;
    let recirculationData = null;
    let renderedRecirculation = null;
    let showMoreButton = false;
    if (!isMobile) {
      numArticles *= 2;
    }

    /*
    Recirculation is a child of 4 different components which can be split into 2 groups:
    - Passes data as a recirculation prop (Article, Author). These components are sent a recirculation property in the response JSON from the Express server.
    - Passes data as an articles prop (NotFound, Confirmation). These components manually fetch their Recirculation data.

    We can probably refactor so that all 4 components send the same recirculation prop. This should be considered for a future refactor.
    */
    let isArticleOrAuthor = typeof recirculation !== "undefined";
    let totalArticles = isArticleOrAuthor ? recirculation.length : articles.length;

    if (articles) {
      recirculationData = this.organizeArticles(numArticles, articles);
    } else if (recirculation.length > 0) {
      recirculationData = this.organizeArticles(numArticles, recirculation);
      showMoreButton = true;
    }

    renderedRecirculation = this.renderArticleCards(recirculationData);

    return (
      <Fragment>
        <div className="article-cards">
          {renderedRecirculation}
        </div>
        
        {showMoreButton && isArticleOrAuthor && renderedRecirculation.length < totalArticles &&
          <div className='see-more' onClick={this.handleSeeMoreClick}>See More</div>
        }
      </Fragment>
    );
  }
}

Recirculation.propTypes = {
  recirculation: PropTypes.array,
  articles: PropTypes.array,
  isMobile: PropTypes.bool,
};

export default Recirculation;
